
import Theme1Card1 from "../../img/Theme1InfoCard1.png"

import Theme1Card2 from "../../img/SectionCard2.png"
import Theme1Card3 from "../../img/Theme1Card3.png"
import Theme1Card4 from "../../img/Theme1Card4.png";
import Theme1Card5 from "../../img/Theme1Card5.png";
import Theme1Card6 from "../../img/Theme1Card6.png";
import Theme1SectionCard1 from "../../img/Theme1SectionCard1.png";

const imageMap = {
  "Theme1InfoCard1.png": Theme1Card1,
  "SectionCard2.png": Theme1Card2,
  "Theme1Card3.png": Theme1Card3,
  "Theme1Card4.png": Theme1Card4,
  "Theme1Card5.png": Theme1Card5,
  "Theme1Card6.png": Theme1Card6,
  "Theme1SectionCard1.png": Theme1SectionCard1,
  
};

export default imageMap;